// custom theme
import { createTheme, Theme } from "@mui/material";
import RoobertLight from "./fonts/Roobert/RoobertLight.woff2";
import RoobertBold from "./fonts/Roobert/RoobertBold.woff2";
import RoobertHeavy from "./fonts/Roobert/RoobertHeavy.woff2";
import RoobertMedium from "./fonts/Roobert/RoobertMedium.woff2";
import RoobertSemiBold from "./fonts/Roobert/RoobertSemiBold.woff2";
import RoobertRegular from "./fonts/Roobert/RoobertRegular.woff2";
import SohneBuch from "./fonts/Sohne/SohneBuch.woff2";
import SohneFett from "./fonts/Sohne/SohneFett.woff2";
import SohneHalbfett from "./fonts/Sohne/SohneHalbfett.woff2";
import SohneDreiviertelfett from "./fonts/Sohne/SohneDreiviertelfett.woff2";
export const lightTheme: Theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#002035",
      light: "#fcf6eb",
      dark: "#ccc3ae",
      contrastText: "#F8F9F9",
    },
    secondary: {
      main: "#fc4c4c",
      dark: "#000",
      light: "#E5E9EB",
      contrastText: "#F5F3EF",
    },
    success: {
      main: "#01C0AA",
      light: "#fafafa",
    },
    common: {
      white: "#fff",
      black: "#000",
    },
    text: {
      primary: "#002035",
      secondary: "#545454",
      disabled: "#252525",
    },
    background: {
      default: "#fff",
      paper: "#fff",
    },
    error: {
      main: "#cc0000",
      light: "#EF4444",
    },
  },
  breakpoints: {
    // values: {
    //   xs: 0,
    //   sm: 600,
    //   md: 1000,
    //   lg: 1200,
    //   xl: 1536,
    // },
  },
  typography: {
    fontFamily: ["Roobert"].join(","),
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "@font-face": {
          fontFamily: "Roobert",
          fontStyle: "normal",
          fontDisplay: "swap",
          fontWeight: 300,
          src: `local('Roobert'), local('RoobertLight'), url(${RoobertLight}) format('woff2');
          `,
        },
        fallbacks: [
          {
            "@font-face": {
              fontFamily: "Roobert",
              fontStyle: "normal",
              fontDisplay: "swap",
              fontWeight: "bold",
              src: `local('Sohne'), local('SohneBuch'), url(${RoobertBold}) format('woff2')`,
            },
          },
          {
            "@font-face": {
              fontFamily: "Roobert",
              fontStyle: "normal",
              fontDisplay: "swap",
              fontWeight: 900,
              src: `local('Roobert'), local('RoobertHeavy'), url(${RoobertHeavy}) format('woff2')`,
            },
          },
          {
            "@font-face": {
              fontFamily: "Roobert",
              fontStyle: "normal",
              fontDisplay: "swap",
              fontWeight: 500,
              src: `local('Roobert'), local('RoobertMedium'), url(${RoobertMedium}) format('woff2')`,
            },
          },
          {
            "@font-face": {
              fontFamily: "Roobert",
              fontStyle: "normal",
              fontDisplay: "swap",
              fontWeight: 600,
              src: `local('Roobert'), local('RoobertSemiBold'), url(${RoobertSemiBold}) format('woff2')`,
            },
          },
          {
            "@font-face": {
              fontFamily: "Roobert",
              fontStyle: "normal",
              fontDisplay: "swap",
              fontWeight: "normal",
              src: `local('Roobert'), local('RoobertRegular'), url(${RoobertRegular}) format('woff2')`,
            },
          },
          {
            "@font-face": {
              fontFamily: "Söhne",
              fontStyle: "normal",
              fontDisplay: "swap",
              src: `local('Sohne'), local('SohneBuch'), url(${SohneBuch}) format('woff2')`,
            },
          },
          {
            "@font-face": {
              fontFamily: "Söhne",
              fontStyle: "semi-bold",
              fontDisplay: "swap",
              fontWeight: 500,
              src: `local('Sohne'), local('SohneHalbfett'), url(${SohneHalbfett}) format('woff2')`,
            },
          },
          {
            "@font-face": {
              fontFamily: "Söhne",
              fontStyle: "bold",
              fontDisplay: "swap",
              fontWeight: 600,
              src: `local('Sohne'), local('SohneDreiviertelfett'), url(${SohneDreiviertelfett}) format('woff2')`,
            },
          },
          {
            "@font-face": {
              fontFamily: "Söhne",
              fontStyle: "bold",
              fontDisplay: "swap",
              fontWeight: 900,
              src: `local('Sohne'), local('SohneFett'), url(${SohneFett}) format('woff2')`,
            },
          },
        ],
      },
    },
  },
});

export const darkTheme: Theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#000",
      light: "#fcf6eb",
      dark: "#5e5e5e",
      contrastText: "#5e5e5e",
    },
    secondary: {
      main: "#fc4c4c",
      dark: "#000",
      light: "#5e5e5e",
      contrastText: "#3e3e3e",
    },
    success: {
      main: "#01C0AA",
      light: "#fafafa",
    },
    common: {
      white: "#fff",
      black: "#000",
    },
    background: {
      default: "#121212",
      paper: "#1e1e1e",
    },
    text: {
      primary: "#fff",
      secondary: "#aeaeae",
      disabled: "#5e5e5e",
    },
    error: {
      main: "#cc0000",
    },
  },
  breakpoints: {
    // values: {
    //   xs: 0,
    //   sm: 600,
    //   md: 1000,
    //   lg: 1200,
    //   xl: 1536,
    // },
  },
  typography: {
    fontFamily: ["Roobert"].join(","),
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "@font-face": {
          fontFamily: "Roobert",
          fontStyle: "normal",
          fontDisplay: "swap",
          fontWeight: 300,
          src: `local('Roobert'), local('RoobertLight'), url(${RoobertLight}) format('woff2');
          `,
        },
        fallbacks: [
          {
            "@font-face": {
              fontFamily: "Roobert",
              fontStyle: "normal",
              fontDisplay: "swap",
              fontWeight: "bold",
              src: `local('Sohne'), local('SohneBuch'), url(${RoobertBold}) format('woff2')`,
            },
          },
          {
            "@font-face": {
              fontFamily: "Roobert",
              fontStyle: "normal",
              fontDisplay: "swap",
              fontWeight: 900,
              src: `local('Roobert'), local('RoobertHeavy'), url(${RoobertHeavy}) format('woff2')`,
            },
          },
          {
            "@font-face": {
              fontFamily: "Roobert",
              fontStyle: "normal",
              fontDisplay: "swap",
              fontWeight: 500,
              src: `local('Roobert'), local('RoobertMedium'), url(${RoobertMedium}) format('woff2')`,
            },
          },
          {
            "@font-face": {
              fontFamily: "Roobert",
              fontStyle: "normal",
              fontDisplay: "swap",
              fontWeight: 600,
              src: `local('Roobert'), local('RoobertSemiBold'), url(${RoobertSemiBold}) format('woff2')`,
            },
          },
          {
            "@font-face": {
              fontFamily: "Roobert",
              fontStyle: "normal",
              fontDisplay: "swap",
              fontWeight: "normal",
              src: `local('Roobert'), local('RoobertRegular'), url(${RoobertRegular}) format('woff2')`,
            },
          },
          {
            "@font-face": {
              fontFamily: "Söhne",
              fontStyle: "normal",
              fontDisplay: "swap",
              src: `local('Sohne'), local('SohneBuch'), url(${SohneBuch}) format('woff2')`,
            },
          },
        ],
      },
    },
  },
});

declare module "@mui/styles/defaultTheme" {
  interface DefaultTheme extends Theme {}
}
